import { render, staticRenderFns } from "./DFAttachedFileURLSub.vue?vue&type=template&id=13d6269a&scoped=true&"
import script from "./DFAttachedFileURLSub.vue?vue&type=script&lang=js&"
export * from "./DFAttachedFileURLSub.vue?vue&type=script&lang=js&"
import style0 from "./DFAttachedFileURLSub.vue?vue&type=style&index=0&id=13d6269a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d6269a",
  null
  
)

export default component.exports